import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { forms as Forms } from '@breezeway/brzw-components';

const { SWITCH_SIZES } = Forms.constants.input;

const BooleanSwitchFormik = ({
  additionalProps,
  className,
  disabled,
  field,
  form,
  label,
  size,
  theme,
  value,
  withIcons,
}) => {
  const { setFieldValue } = form;
  const { name } = field;

  return (
    <Forms.BooleanSwitch
      {...field}
      className={className}
      disabled={disabled}
      label={label}
      name={name}
      onChange={() => setFieldValue(name, !value)}
      size={size}
      theme={theme}
      value={value}
      withIcons={withIcons}
      {...additionalProps}
    />
  );
};

BooleanSwitchFormik.propTypes = {
  additionalProps: PropTypes.shape({}),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  field: PropTypes.shape({}),
  form: PropTypes.shape({}),
  label: PropTypes.string,
  size: PropTypes.oneOfType(_.values(SWITCH_SIZES)),
  theme: PropTypes.string,
  value: PropTypes.bool,
  withIcons: PropTypes.bool,
};

BooleanSwitchFormik.defaultProps = {
  additionalProps: {},
  className: '',
};

export default BooleanSwitchFormik;
